import { Helmet } from "react-helmet-async"
import { ISupplier, SupplierAccountings } from "../../../../Supplier"
import { useOutletContext } from "react-router"

export default function SupplierAccountingsPage() {
	const { transportServiceProvider } = useOutletContext<{
		transportServiceProvider: ISupplier
		revalidate: () => void
	}>()
	return (
		<>
			<Helmet>
				<title>Accounting | Supplier</title>
			</Helmet>
			<SupplierAccountings supplier={transportServiceProvider} />
		</>
	)
}
